"use client";

import { Badge } from "@/components/ui/badge";
import { CheckCircle, AlertCircle, FileEdit } from "lucide-react";

interface AgentStatusBadgeProps {
  status: "draft" | "active" | "disabled";
}

export function AgentStatusBadge({ status }: AgentStatusBadgeProps) {
  switch (status) {
    case "active":
      return (
        <Badge className="bg-green-100 text-green-800 hover:bg-green-100">
          <CheckCircle className="w-3 h-3 mr-1" />
          <span>Active</span>
        </Badge>
      );
    case "draft":
      return (
        <Badge className="bg-gray-100 text-gray-800 hover:bg-gray-100">
          <FileEdit className="w-3 h-3 mr-1" />
          <span>Draft</span>
        </Badge>
      );
    case "disabled":
      return (
        <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-100">
          <AlertCircle className="w-3 h-3 mr-1" />
          <span>Disabled</span>
        </Badge>
      );
    default:
      return null;
  }
}
